var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.00004C18 4.02945 13.9706 0 9.00001 0C4.02943 0 0 4.02945 0 9.00004C0 13.4922 3.29117 17.2156 7.59375 17.8907V11.6016H5.3086V9.00004H7.59375V7.01722C7.59375 4.76158 8.93738 3.51564 10.9932 3.51564C11.9779 3.51564 13.0078 3.69142 13.0078 3.69142V5.90627H11.8729C10.7549 5.90627 10.4063 6.60004 10.4063 7.31178V9.00004H12.9024L12.5033 11.6016H10.4062V17.8907C14.7088 17.2156 18 13.4922 18 9.00004Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5034 11.6016L12.9024 9.00001H10.4063V7.31175C10.4063 6.60001 10.755 5.90625 11.873 5.90625H13.0079V3.6914C13.0079 3.6914 11.9779 3.51562 10.9933 3.51562C8.93743 3.51562 7.59378 4.76156 7.59378 7.0172V9.00001H5.30859V11.6016H7.59378V17.8907C8.05898 17.9636 8.52916 18.0002 9.00005 18C9.47846 18 9.94809 17.9626 10.4063 17.8907V11.6016H12.5034Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.3da8ec84.svg";
export { ForwardRef as ReactComponent };